<div class="shop-list" data-analytics="my_shop_list">
  @for (shop of shops(); track shop.name) {
    <sd-shop-list-item
      id="shop-{{ shop.name }}"
      [shop]="shop"
      [activeShopName]="activeShopName()"
      [showAvailability]="showAvailability()"
      (clickShop)="onClickShop($event)"
    ></sd-shop-list-item>
  }
</div>
